import { useCallback } from "react"

declare const gtag: any;
export default function useGtagEvent() {
    return useCallback((action: string, label: string, params?: {[key:string]: string | number}) => {
        if (gtag) {
            gtag('event', action, {
                event_label: label,
                ...params
            })
        }
    }, [])
}
